import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { PolicyService } from "@shared/services/policy.service";
import { PAGE_NON_TROUVEE } from "@shared/constants/route.constants";
import { setPolicyId } from "@shared/state/context/context.actions";

@Component({
  selector: "app-detail-contrat-redirect",
  template: "",
})
export class DetailContratRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contratService: PolicyService,
    private store: Store
  ) {}

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get("id");

    console.log("DetailContratRedirectComponent: Redirecting to contract details for ID:", idParam);
    if (idParam) {
      this.contratService.getPolicyId(idParam).subscribe({
        next: id => {
          this.store.dispatch(setPolicyId({ policyId: id }));
          this.router.navigate([`/contrat/${id}/details`]);
        },
        error: () => {
          this.router.navigate([PAGE_NON_TROUVEE]);
        },
      });
    } else {
      this.router.navigate([PAGE_NON_TROUVEE]);
    }
  }
}
